import {Get, Put, Post} from "para-lib";
import {API_CONFIG, PORTAL_CTX, PORTAL_CFG_CTX, PORTAL_SSO_CTX, PORTAL_SELF} from "../config/api.config";

const CTX = {ctx: PORTAL_CTX};
/**
 * 陈夕 2020/7/24 上午10:07
 * desc: 获取用户信息
 * @params
 **/
export const getUserInfo = () => Get({url: API_CONFIG.USERINFO, ...CTX});

/**
 * 陈夕 2020/7/24 下午3:31
 * desc: 修改用户信息
 * @params
 **/
export const updateUserInfo = (data: any) => {
    return Put({url: API_CONFIG.USERINFO, data, ...CTX});
};
/**
 * 陈夕 2020/7/27 下午5:00
 * desc: 修改用户密码
 * @params
 **/
export const updatePassword = (data: any) => Post({url: API_CONFIG.changePassword, data, ...CTX});


/**
 * 陈夕 2020/7/27 下午5:36
 * desc: 获取密码策略信息
 * @params
 **/
export const getPasswordPolicy = (url: string) => Get({url: url, ...CTX});

/**
 * joe 2020/7/28 上午11:06
 * desc: 获取验证码 1未认证,0认证
 * type: string, provider: string, unAuth: number = 0, templateEnum: string = "P_RESET"
 * @params
 **/
export const getAuthCode = ({type, provider, status, template}: any) => {
    if (!template) template = "P_RESET";
    let url = API_CONFIG.sendCode + "?messageType=" + type + "&provider=" + provider + "&templateEnum=" + template;
    if (status !== 0) {
        // 未认证的接口 // templateEnum= P_RESET | S_MAIL_DETERMINATION -》forger
        url = API_CONFIG.unauthorizedSendCode + "?messageType=" + type + "&provider=" + provider;
    }
    return Get({url, ...CTX});
};

/**
 * joe 2020/7/28 上午11:10
 * desc:
 * @params
 **/
// 校验验证码 1未认证,0认证
export const checkAuthCode = ({type, provider, status, template, code}: any) => {
    let url = API_CONFIG.checkProvider + "?messageType=" + type + "&provider=" + provider + "&code=" + code + "&templateEnum=" + template;
    if (status !== 0) {
        // 未认证的接口
        url = API_CONFIG.unauthorizedCheckProvider + "?messageType=" + type + "&provider=" + provider + "&code=" + code;
    }
    return Post({url, ...CTX});
};
/**
 * joe 2020/7/28 上午11:14
 * desc: 获取验证码配置的信息例如时间  0未认证, 1认证
 * @params
 **/
export const getMessagePolicy = (params = 0) => {
    let url = API_CONFIG.getUnAuthAllV1; // 未认证
    if (params === 1) {
        url = API_CONFIG.getUnAuthAllV1; // 认证
    }
    return Get({
        url, params: {fiql: "(cfgtype==sms_msg_policy,cfgtype==email_msg_policy)"},
        ctx: PORTAL_CFG_CTX
    });
};

/**
 * joe 2020/7/29 上午9:36
 * desc: 获取所有互联网绑定数据
 * @params
 **/
export const getCertificationAll = () => Post({
    url: API_CONFIG.internetIsBindAll,
    ctx: PORTAL_SSO_CTX
});

/**
 * jilanlan 2020-12-18 14:49
 * desc: 获取个性化信息
 * @params
 **/
export const getIndexHeader = () => Get({
    url: API_CONFIG.headerInfo,
    ctx: PORTAL_CTX
});
